module.exports = __webpack_public_path__ + "static/img/dynamico.a79416f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamico.png
// module id = 43mA
// module chunks = 45